// extracted by mini-css-extract-plugin
module.exports = {"FaLayerGroup":"form-proa_FaLayerGroup__1wU2b","tabTitle":"form-proa_tabTitle__3usNn"};